<ng-container [ngSwitch]="displayMode" xmlns="http://www.w3.org/1999/html">
    <!-- Flat Mode Menu -->
    <ul *ngSwitchCase="'flat'" class="menu-flat--level-1">
        <li *ngFor="let item of tree.nodes; let i = index">
            <ng-container *ngIf="!item.children?.length; else children">
                <a *ngIf="!isExternalLink(item.url)"
                   [routerLink]="item.url"
                   routerLinkActive="active">
                    {{item.name}}
                </a>
                <a *ngIf="isExternalLink(item.url)"
                   [href]="item.url">
                    {{item.name}}
                </a>
            </ng-container>
            <ng-template #children>
                <ng-container [ngSwitch]="headingLevel">
                    <h2 [id]="'menu-flat-list-label-'+cmpID+'-'+i" *ngSwitchCase="2">{{item.name}}</h2>
                    <h3 [id]="'menu-flat-list-label-'+cmpID+'-'+i" *ngSwitchCase="3">{{item.name}}</h3>
                    <h4 [id]="'menu-flat-list-label-'+cmpID+'-'+i" *ngSwitchCase="4">{{item.name}}</h4>
                    <h5 [id]="'menu-flat-list-label-'+cmpID+'-'+i" *ngSwitchCase="5">{{item.name}}</h5>
                    <h6 [id]="'menu-flat-list-label-'+cmpID+'-'+i" *ngSwitchCase="6">{{item.name}}</h6>
                    <div class="menu-flat--level-1-title" [id]="'menu-flat-list-label-'+cmpID+'-'+i"
                         *ngSwitchDefault>{{item.name}}</div>
                </ng-container>
                <ng-content select=".title-level"></ng-content>
                <ul class="menu-flat--level-2" [attr.aria-labelledby]="'menu-flat-list-label-'+cmpID+'-'+i">
                    <ng-container *ngTemplateOutlet="recursiveListTmpl; context: {list:item, i:2}"></ng-container>
                </ul>
            </ng-template>
        </li>
    </ul>

    <ng-template #recursiveListTmpl let-list="list" let-i="i+1">
        <li *ngFor="let subitem of list.children" [class]="subitem.class">
            <ng-container *ngIf="subitem.url?.length">
                <a *ngIf="!isExternalLink(subitem.url)"
                   [routerLink]="subitem.url"
                    routerLinkActive="active">
                    {{subitem.name}}
                </a>
                <a *ngIf="isExternalLink(subitem.url)"
                   [href]="subitem.url">
                    {{subitem.name}}
                </a>
            </ng-container>
            <span *ngIf="!subitem.url?.length">{{subitem.name}}</span>
            <ul *ngIf="subitem.children?.length > 0" [class]="'level-'+i">
                <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: subitem, i:i }"></ng-container>
            </ul>
        </li>
    </ng-template>


    <!-- /Flat Mode Menu -->

    <!-- Old Tree Pattern -->
    <div *ngSwitchCase="'tree'" class="taxonomy-menu" [class.selected]="selectedNode">
<!--        <tree-root #treeCmp *ngIf="tree.nodes.length"-->
<!--                   [nodes]="tree.nodes"-->
<!--                   [options]="tree.options"-->
<!--                   [focused]="true"-->
<!--                   (initialized)="initializedTree()"-->
<!--                   (toggleExpanded)="onExpandNode($event)">-->
<!--            <ng-template #treeNodeFullTemplate-->
<!--                         let-node-->
<!--                         let-index="index"-->
<!--                         let-templates="templates">-->
<!--                <div-->
<!--                        [ngClass]="{'is-selected': node == selectedNode}"-->
<!--                        [class]="node.getClass() + ' ' + node.data?.class"-->
<!--                        [class.tree-node]="true"-->
<!--                        [class.tree-node-expanded]="node.isExpanded && node.hasChildren"-->
<!--                        [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"-->
<!--                        [class.tree-node-leaf]="node.isLeaf"-->
<!--                        [class.tree-node-active]="node.isActive"-->
<!--                        [class.tree-node-focused]="node.isFocused"-->
<!--                        [class.last-selected]="node==selectedNode">-->

<!--                    <tree-node-drop-slot-->
<!--                            *ngIf="index === 0"-->
<!--                            [dropIndex]="node.index"-->
<!--                            [node]="node.parent">-->
<!--                    </tree-node-drop-slot>-->

<!--                    <div class="node-wrapper" [style.padding-left]="node.getNodePadding()"-->
<!--                         *ngIf="!hideSiblings || (!selectedNode || (node == selectedNode || node.parent == selectedNode))">-->
<!--                        <div class="node-content-wrapper"-->
<!--                             [class.node-content-wrapper-active]="node.isActive"-->
<!--                             [class.node-content-wrapper-focused]="node.isFocused"-->
<!--                             (click)="node.mouseAction('click', $event)"-->
<!--                             (dblclick)="node.mouseAction('dblClick', $event)"-->
<!--                             (contextmenu)="node.mouseAction('contextMenu', $event)"-->
<!--                             (treeDrop)="node.onDrop($event)"-->
<!--                             [treeAllowDrop]="node.allowDrop"-->
<!--                             [treeDrag]="node"-->
<!--                             [treeDragEnabled]="node.allowDrag()">-->

<!--                            <div *ngIf="node.data?.url ; else expandBlock;">-->
<!--                                <a class="menu-item external-link" *ngIf="isExternalLink(node.data.url) else innerLink;"-->
<!--                                   [href]="node.data.url">-->
<!--                                    {{node.data?.name}}-->
<!--                                </a>-->
<!--                                <ng-template #innerLink>-->
<!--                                    <a class="menu-item inner-link" [routerLink]="node.data.url"-->
<!--                                       routerLinkActive="active">-->
<!--                                        {{node.data?.name}}-->
<!--                                    </a>-->
<!--                                </ng-template>-->
<!--                            </div>-->

<!--                            <ng-template #expandBlock>-->
<!--                                <span class="menu-item title"-->
<!--                                      (click)="expandNode($event, node)">{{node.data?.name}}</span>-->
<!--                            </ng-template>-->
<!--                        </div>-->
<!--                        <tree-node-expander [node]="node"></tree-node-expander>-->
<!--                    </div>-->

<!--                    <tree-node-children [node]="node" [templates]="templates">-->
<!--                    </tree-node-children>-->
<!--                    <tree-node-drop-slot [dropIndex]="node.index + 1" [node]="node.parent">-->
<!--                    </tree-node-drop-slot>-->
<!--                </div>-->
<!--            </ng-template>-->
<!--        </tree-root>-->
    </div>
    <!-- Old Tree Pattern -->

    <!-- Select -->
    <div *ngSwitchCase="'select'" class="taxonomy-menu" [class.selected]="selectedNode">
        <mat-form-field name="taxonomyMenu">
            <mat-select (selectionChange)="navigateTo($event.value)" [(value)]="currentUrl">
                <mat-option *ngFor="let item of tree.nodes; let i = index" [value]="item.url">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!-- Select -->

    <!-- Select menu-->
    <div *ngSwitchCase="'selectmenu'" class="taxonomy-menu" [class.selected]="selectedNode" >
        <mat-form-field name="taxonomyMenu" class="selectmenu">
            <div dir="{{dir}}">
            <mat-select disableOptionCentering="true" (selectionChange)="onTargetIdClicked($event.value)" [(value)]="selectedOnMenu" [panelClass]="selectPanelClass">
                <mat-option *ngFor="let item of tree.nodes; let i = index" [value]="item.name" [id]="item.url">
                    {{item.name}}
                </mat-option>
            </mat-select>
            </div>
        </mat-form-field>
    </div>

    <!-- Select menu-->
    <div *ngSwitchCase="'flat_single_level'" class="taxonomy-menu" [class.selected]="selectedNode" >
        <div *ngIf="currentItemLink">
            <button *ngIf="currentItemLink.parent" class="btn"
                    (click)="currentItemLink = currentItemLink.parent;currentLevel=currentLevel-1">
                <i class="fa fa-close"></i>
            </button>
            <h3>{{currentItemLink.data.name}}</h3>
            <ul class="nav fadeIn menu-container menu-level-{{currentLevel}}"
                data-mdb-animation="fade-in-right"
                data-mdb-animation-start="onHover"
                data-mdb-toggle="animation"
                data-mdb-animation-reset="true">
                <li *ngFor="let node of currentItemLink.tree.treeItems; let subindex=index; let isFirst = first"
                    [attr.aria-setsize]="currentItemLink.tree.treeItems.length"
                    data-toggle="collapse"
                    [class.nav-item]="!disableBsClasses"
                    [class.has-children]="node.data.children"
                    [class.has-img]="node.data.file_preview"
                    [class.active]="router.url==node.data.url"
                    aria-posinset="subindex"
                    [class]="node.data.class"
                >
                    <ng-container  [ngSwitch]="node.linkType">
                        <a *ngSwitchCase="'INNER_LINK'"
                           [id]="'single-node-' + node.nodeId"
                           [attr.aria-current]="router.url==node.data.url?'page':null"
                           [class.nav-link]="!disableBsClasses"
                           [class]="node.data.class"
                           routerLink
                           (click)="onTargetIdClicked(node.data.url)">
                            <img *ngIf="node.data.file_preview" [src]="node.data.file_preview" [alt]="node.data.alt">
                            <span [hidden]="node.data.file_preview && node.data.alt && !shareDataService.isBpUp(transitionPoint)">{{node.data.name}}</span>
                        </a>
                        <a *ngSwitchCase="'EXTERNAL_LINK'"
                           [id]="'single-node-' + node.nodeId"
                           [class.nav-link]="!disableBsClasses"
                           [class]="node.data.class"
                           routerLink
                           (click)="onTargetIdClicked(node.data.url)">
                            <img *ngIf="node.data.file_preview" [src]="node.data.file_preview" [alt]="node.data.alt">
                            <span [hidden]="node.data.file_preview && node.data.alt && !shareDataService.isBpUp(transitionPoint)">{{node.data.name}}</span>
                        </a>

                        <button *ngSwitchDefault
                                [id]="'single-node-' + node.nodeId"
                                (click)="selectNode(node)"
                                [class.nav-link]="!disableBsClasses"
                                [autofocus]="currentLevel > 1 && isFirst ? true: false"
                                [focus]="currentLevel > 1 && isFirst ? true: false"
                        >
                            <img *ngIf="node.data.file_preview" [src]="node.data.file_preview" [alt]="node.data.alt">
                            <i *ngIf="node.tree" class="fa fa-angle-left"></i>
                            <span [hidden]="node.data.file_preview && node.data.alt">{{node.data.name}}</span>
                        </button>
                    </ng-container>
                </li>
            </ul>
        </div>
    </div>
    <!-- Select menu-->

    <!-- Conventional Menu Pattern -->
    <ul *ngSwitchDefault
        [class.nav]="!disableBsClasses"
        [class.flex-column]="!shareDataService.isBpUp(transitionPoint)||level1V"
        class="menu-container menu-level-1">
        <ng-container *ngTemplateOutlet="recursiveMenu; context: {menus:tree.nodes, i:1}"></ng-container>
    </ul>
    <ng-template #recursiveMenu let-menus="menus" let-i="i+1">
        <li *ngFor="let menu of menus; let subindex=index"
            data-toggle="collapse"
            [class.nav-item]="!disableBsClasses"
            [class.dropdown]="menu.children&&shareDataService.isBpUp(transitionPoint)"
            [class.open-by-hover]="expandByHover"
            [class.has-children]="menu.children"
            [class.isBlock]="menu.block"
            [class.has-img]="menu.file_preview"
            [class.active]="router.url==menu.url"
            [class]="menu.class">
            <ng-container
                    [ngTemplateOutlet]="menu.block? blockTemp : !menu.children ? link : shareDataService.isBpUp(transitionPoint) ? submenu : submenuMobile"></ng-container>
            <ng-template #link>
                <span *ngIf="enableTaxonomySubjectSearch"
                      [attr.aria-current]="router.url==menu.url?'page':null"
                      [class.nav-link]="!disableBsClasses"
                      [class.dropdown-item]="i>2&&shareDataService.isBpUp(transitionPoint)"
                      [class]="menu.class"
                      (click)="onTargetIdClicked(menu.url)">
                    <img *ngIf="menu.file_preview" [src]="menu.file_preview" [alt]="menu.alt">
                    <span [hidden]="menu.file_preview && menu.alt && !shareDataService.isBpUp(transitionPoint)" [innerHTML]="menu.name | safe: 'html'"></span>
                </span>
                <a *ngIf="!enableTaxonomySubjectSearch && !isExternalLink(menu.url)"
                   [attr.aria-current]="router.url==menu.url?'page':null"
                   [attr.tabindex]="i>2&&shareDataService.isBpUp(transitionPoint)?'-1':''"
                   [class.nav-link]="!disableBsClasses"
                   [class.dropdown-item]="i>2&&shareDataService.isBpUp(transitionPoint)"
                   [class]="menu.class"
                   [routerLink]="menu.url"
                   (click)="onTargetIdClicked(menu.url)">
                    <img *ngIf="menu.file_preview" [src]="menu.file_preview" [alt]="menu.alt">
                    <span [hidden]="menu.file_preview && menu.alt && !shareDataService.isBpUp(transitionPoint)" [innerHTML]="menu.name | safe: 'html'"></span>
                </a>
                <a *ngIf="!enableTaxonomySubjectSearch && isExternalLink(menu.url)"
                   [class.nav-link]="!disableBsClasses"
                   [class.dropdown-item]="i>2&&shareDataService.isBpUp(transitionPoint)"
                   [class]="menu.class"
                   [href]="menu.url"
                   (click)="onTargetIdClicked(menu.url, menu.target, $event)">
                    <img *ngIf="menu.file_preview" [src]="menu.file_preview" [alt]="menu.alt">
                    <span [hidden]="menu.file_preview && menu.alt && !shareDataService.isBpUp(transitionPoint)" [innerHTML]="menu.name | safe: 'html'"></span>
                </a>
                <div *ngIf="menu.component" [innerHTML]="menu.component | safe: 'html'"></div>
            </ng-template>

            <ng-template #submenu>
                <button [id]="'dropdownMenuButton-'+cmpID+'-'+i+'-'+subindex"
                        class="dropdown-toggle"
                        [class.nav-link]="!disableBsClasses"
                        [class.dropdown-item]="i>2"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        (click)="onTargetIdClicked(menu.url)">
                    <img *ngIf="menu.file_preview" [src]="menu.file_preview" [alt]="menu.alt">
                    <span [hidden]="menu.file_preview && menu.alt">{{menu.name}}</span>
                </button>
                <ul role="menu"
                    [attr.aria-labelledby]="'dropdownMenuButton-'+cmpID+'-'+i+'-'+subindex"
                    [class]="'dropdown-menu list-unstyled menu-level-'+i"
                    [id]="'menu-'+cmpID+'-'+i+'-'+subindex"
                    [class.horizontal]="level2H">
                    <ng-container *ngTemplateOutlet="recursiveMenu; context: {menus:menu.children, i:i}"></ng-container>
                </ul>
            </ng-template>
            <ng-template #submenuMobile>
                <button [id]="'dropdownMenuButton-'+cmpID+'-'+i+'-'+subindex"
                        [attr.aria-controls]="'menu-'+cmpID+'-'+i+'-'+subindex"
                        (click)="onMobileSubmenuClick($event, i)"
                        [class]="menu.class"
                        class="submenu-mobile-controller"
                        aria-expanded="false">
                    <img class="controller-img" *ngIf="menu.file_preview" [src]="menu.file_preview" alt="">
                    <span class="controller-text">{{menu.name}}</span>
                    <i class="fa fa-angle-down"></i>
                </button>

                <ul role="menu"
                    [attr.aria-labelledby]="'dropdownMenuButton-'+cmpID+'-'+i+'-'+subindex"
                    class="submenu-mobile list-unstyled"
                    [class]="'menu-level-'+i"
                    [id]="'menu-'+cmpID+'-'+i+'-'+subindex">
                    <ng-container *ngTemplateOutlet="recursiveMenu; context: {menus:menu.children, i:i}"></ng-container>
                </ul>
            </ng-template>
            <ng-template #blockTemp>
                <entity-block [entityVar]="menu.block"> </entity-block>
            </ng-template>
        </li>
    </ng-template>
    <!-- /Conventional Menu Pattern -->
</ng-container>
